import {FilterLineupsByPlayerInterface} from './filter-lineups-by-player-interface';

export function getFilteredLineupsByPlayer(lineups, filterLineupsByPlayer: FilterLineupsByPlayerInterface) {
    if (!filterLineupsByPlayer.hasCheckedPlayers()) {
        return Object.values(lineups.all());
    }

    const lineupIds = filterLineupsByPlayer.getLineupIds();

    return lineupIds.map((lineupId) => lineups.getLineup(lineupId)).filter((lineup) => lineup !== null);
}

export function filterUsedPlayers(usedPlayers, filterLineupsByPlayer: FilterLineupsByPlayerInterface) {
    if (!filterLineupsByPlayer.hasCheckedPlayers()) {
        return Object.values(usedPlayers.all());
    }

    const playerIds = filterLineupsByPlayer.getUsedPlayerIds();

    const filteredPlayers: object[] = [];
    playerIds.map((playerId) => {
        const players = usedPlayers.getPlayers(playerId);
        if (!isEmpty(players)) {
            players.map((player) => filteredPlayers.push(player));
        }
    });

    return filteredPlayers;
}
